module.exports = __webpack_public_path__ + "img/framework.47d2c9e4.png";